import {NosotrosPage} from './NosotrosPage';
export default NosotrosPage;